<div class="color-bar"></div>

<div class="conteudo">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'relatorioVeiculos.veiculoEstoque.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtroDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>
            <div class="row ptb50">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.dataInicial'}}
                </div>
                <p-calendar [disabled]="datas.tipo_data==3" [(ngModel)]="datas.data_inicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  (onClearClick)="limpaDataInicial()" [monthNavigator]="true" yearRange="2000:2030"
                  placeholder="{{'relatorioVeiculos.veiculoVendido.dataInicialPlaceHolder' | translate}}"
                  showButtonBar="true">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.dataFinal'}}
                </div>
                <p-calendar [disabled]="datas.tipo_data==3" [(ngModel)]="datas.data_final" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" (onClearClick)="limpaDataFinal()"
                  placeholder="{{'relatorioVeiculos.veiculoVendido.dataFinalPlaceHolder' | translate}}"
                  showButtonBar="true" [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'relatorioVeiculos.veiculoVendido.tipoData'}}
                </div>
                <p-dropdown translate [options]="tipoData" [(ngModel)]="datas.tipo_data" optionLabel="name" optionValue="value"></p-dropdown>
              </div>
              <div class="col col-3">
                <button translate class="btn btn-primary mt-3 mr-2" type="button" (click)="pesquisar()">
                  {{'relatorioVeiculos.veiculoEstoque.filtrar'}}
                  <i class="fa fa-search"></i>
                </button>
                <button translate class="btn mt-3" type="button" [class.btn-info]="!getListagemComFiltros()"
                  [class.btn-warning]="getListagemComFiltros()" (click)="definirFiltro();">
                  {{'relatorioVeiculos.veiculoEstoque.maisFiltros'}}
                  <i class="fa fa-filter"></i>
                </button>
              </div>
            </div>
            <hr>
          </div>
        </div>
      </div>
    </div>
    <app-veiculo-estoque-filtro (definirFiltro)="definirFiltro()" [filtros]="filtros"></app-veiculo-estoque-filtro>
    <app-veiculo-estoque-lista (exibir)="selecionar($event)" [carregar]="filtrar()" [datas]="datas">
    </app-veiculo-estoque-lista>
  </div>
</div>
<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers [(visible)]="displayFiltrosDealers" [dealers]="filtroDealers.dealers"
  [headerTitle]="'relatorioVeiculos.veiculoEstoque.selecioneDealers'"
  [filterPlaceholder]="'relatorioVeiculos.veiculoEstoque.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>